module.exports = __webpack_public_path__ + "static/media/top-trending.36e5a0a4.png";